/* eslint-disable no-param-reassign */

export default {
  setAuth: (state, isAuthenticated) => {
    state.isAuth = isAuthenticated;
  },
};
